import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PersonPictureModule } from '../../person-picture/person-picture.module';
import { IconFontModule } from '../icon-font/icon-font.module';
import { ActivityDescriptionComponent } from './activity-description.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule,
        PersonPictureModule
    ],
    declarations: [
        ActivityDescriptionComponent
    ],
    exports: [
        ActivityDescriptionComponent
    ]
})

export class ActivityDescriptionModule {
}
